import styled, { css } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const Container = styled.div<{
  withButtonScroll: boolean;
  minWidth: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: ${({ minWidth }) => (minWidth ? 'min-content' : '100%')};
  gap: 8px;

  ${({ withButtonScroll }) =>
    withButtonScroll &&
    css`
      position: relative;
      width: 100%;
      max-width: 100%;
      z-index: 10;
    `}
`;

export const OptionsContainer = styled.ul<{
  justifyOptions: string;
  optionsGap: string;
  withUnderlineBorder: boolean;
  fullWidth: boolean;
  withButtonScroll: boolean;
  maxWidthAndSpaceBetween: boolean;
  withoutOverflowX: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;

  justify-content: ${({ justifyOptions, maxWidthAndSpaceBetween }) =>
    maxWidthAndSpaceBetween ? 'space-between' : justifyOptions};
  gap: ${({ optionsGap }) => optionsGap};
  padding-top: ${SPACING._14};
  padding-bottom: ${SPACING._14};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'min-content')};
  border-bottom: ${({ withUnderlineBorder, theme }) =>
    withUnderlineBorder ? `1px solid ${theme.neutral[800]}` : 'none'};
  position: relative;
  overflow-x: auto;
  max-width: 100%;
  scrollbar-width: thin;

  ${({ maxWidthAndSpaceBetween }) =>
    maxWidthAndSpaceBetween &&
    css`
      max-width: 100%;
      width: 100%;
      gap: 0;
      overflow-x: hidden;
    `}

  ${({ withoutOverflowX }) =>
    withoutOverflowX &&
    css`
      overflow-x: hidden;
    `}

  ${({ withButtonScroll }) =>
    withButtonScroll &&
    css`
      overflow-x: hidden;
      width: 100%;
    `}
`;

export const OptionWrapper = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SelectedBorder = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.green[500]};
  transition: 200ms;
`;

export const RightIconWrapper = styled.div`
  position: absolute;
  right: 0;
`;
